import { AspSyncRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useTriggerAspSync() {
  const api = useApi();
  const [syncing, setSyncing] = useState(false);

  async function triggerAspSync(params: AspSyncRequest) {
    try {
      setSyncing(true);
      const res = await api.triggerAspSync(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSyncing(false);
    }
  }

  return { syncing, triggerAspSync };
}
